<template>
	<div class="login">
		<comp-loading/>
		<v-container align-content-center grid-list-xl text-xs-center >
			<v-layout column justify-content-center>
				<v-flex xs12 md6 mt-5 mb-3>
					<img src="@/assets/logo_big.png" class="logo_big" />
				</v-flex>
				<v-flex xs12 md6>
					<v-form ref="loginForm">
						<v-layout justify-center>
							<v-flex xs12 md5>
								<v-card class="pa-5 my-elevation-1">
									<v-text-field
										class="text-center"
										color="info"
										v-model="formData.email"
										label="Usuario"
										required
										
									></v-text-field>
									<v-text-field
										color="info"
										v-model="formData.password"
										label="Contraseña"
										type="password"
				            required
									></v-text-field>
									<v-card-actions class="d-block text-xs-center">
										<v-btn
											class="elevation-0"
											color="success"
											@click="onSubmit"
										>
											Entrar
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-flex>
						</v-layout>
					</v-form>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import { staticSetup, typeLogins } from '@/config.js'
import { mapState } from 'vuex'

import compLoading from '@/components/Loading/Loading'

export default {
	components: {
		compLoading
	},
	data() {
		return {
			staticSetup,
			show1: false,
			formData: {
				email: '',
				password: ''
			},
			formRules: {
				emailRule: [
					v => !!v || 'Debes introducir un email',
					v => /.+@.+\./.test(v) || 'El email no es válido'
				]
			}
		}
	},
	computed: {
		...mapState('login', ['token'])
	},
	watch: {
		token(e) {
			if (e) {
				this.$router.go()
			}
		}
	},
	methods: {
		// TODO: panel de register
		/* register() {
			if (this.$refs.loginForm.validate()) {
				this.$store.commit('setLoading', true)
				this.$store.dispatch('login/register', {type: 'emailAndPassword', data: this.formData, onlyReg: true})
			}
		}, */
		onSubmit() {
			if (this.$refs.loginForm.validate()) {
				this.$store.commit('setLoading', true)
				if (typeLogins.type == "simple") {
					this.$store.dispatch('login/loginSimple', this.formData)
				} else {
					this.$store.dispatch('login/signIn', this.formData)
				}
			}
		}
	},
	created() {
		this.$store.commit('setLoading', false)
	}
}
</script>
